import { Box, Divider, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { DialogTabs } from "@/components/ui-v2/DialogTabs/DialogTabs";
import { TABS_CONTENT } from "@/components/ui-v2/FilePicker/constants";
import { useFilePickerState } from "@/components/ui-v2/FilePicker/state";
import type {
  Category,
  FilepickerFile,
} from "@/components/ui-v2/FilePicker/types";
import { UploadButton } from "@/components/ui-v2/UploadButton/UploadButton";

interface FilePickerTabsProps {
  value: Category;
  maxFiles?: number;
  categories: Category[];
}

const TabsContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  width: 200,
  borderRight: "1px solid",
  borderColor: theme.palette.divider,
  overflowY: "auto",
}));

const UploadButtonContainer = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const FilePickerTabs = (props: FilePickerTabsProps) => {
  const { value, categories } = props;
  const {
    setCategoryTab,
    maxFiles,
    acceptedFileTypes,
    modality,
    setIsUploading,
    setSelectedFiles,
    setSelectionAsConfirmed,
  } = useFilePickerState();

  const handleChange = (_: React.SyntheticEvent, newCategory: string) => {
    setCategoryTab(newCategory as Category);
  };

  const handleUploadStart = () => {
    setIsUploading(true);
  };

  const handleUploadSuccess = (files: FilepickerFile[]) => {
    setIsUploading(false);
    setSelectedFiles(files);
    setSelectionAsConfirmed();
  };

  return (
    <TabsContainer>
      <DialogTabs
        tabsContent={TABS_CONTENT.filter((tab) =>
          categories.includes(tab.value as Category),
        )}
        value={value}
        onChange={handleChange}
      />
      <Box
        sx={{
          px: 1,
          textAlign: "center",
        }}
      >
        <Divider textAlign="center">
          <Typography
            sx={{
              color: "secondary.3",
            }}
          >
            or
          </Typography>
        </Divider>
        <UploadButtonContainer>
          <UploadButton
            testId="btn-upload-file"
            sx={{ mb: 1 }}
            variant="outlined"
            sourceType="REFERENCE"
            onUploadStart={handleUploadStart}
            onUploadSuccess={handleUploadSuccess}
            accept={acceptedFileTypes}
            maxFiles={maxFiles}
            modality={modality}
            fullWidth
          />
        </UploadButtonContainer>
        <Divider textAlign="center">
          <Typography
            sx={{
              color: "secondary.3",
            }}
          >
            or
          </Typography>
        </Divider>
        <Typography
          variant="small"
          sx={{
            color: "secondary.2",
          }}
        >
          Paste from your clipboard
        </Typography>
      </Box>
    </TabsContainer>
  );
};
